import React, { useEffect } from "react";
import { LOG_OUT } from '../redux/actions/type'
import { useDispatch } from 'react-redux'
import { routersHelper } from '../helpers'

const Logout = () => {
    const { useRouter } = routersHelper
    const dispatch = useDispatch()
    const router = useRouter()
    const { query: { goto } } = router
    const path = goto.charAt(0) !== '/' ? `/${goto}` : goto
    useEffect(() => {
        dispatch({
            type: LOG_OUT,
            payload: {
                path,
                router
            }
        })
    }, [path, router, dispatch])
    return <></>;
};


export default Logout;
